<template>
  <div class="card card-custom card-stretch">
    <div class="card-header border-0">
      <h3 class="card-title text-dark">لینک دانلود نرم افزارهای کاربردی</h3>
    </div>
    <div class="card-body pt-2 pb-4">
      <div class="d-flex align-items-center flex-wrap mb-5">
        <div class="symbol symbol-50 symbol-light mr-5">
          <span class="symbol-label">
            <img
              src="/media/apps/vmix-logo.png"
              class="h-50 align-self-center"
              alt=""
            />
          </span>
        </div>
        <div class="d-flex flex-column flex-grow-1 mr-2">
          <a
            href="https://www.vmix.com/software/download.aspx"
            target="_blank"
            class="font-weight-bolder text-dark-75 text-hover-primary font-size-lg mb-1"
          >
            نرم افزار vmx
          </a>
        </div>
      </div>
      <div class="d-flex align-items-center flex-wrap mb-5">
        <div class="symbol symbol-50 symbol-light mr-5">
          <span class="symbol-label">
            <img
              src="/media/apps/obs-logo.png"
              class="h-50 align-self-center"
              alt=""
            />
          </span>
        </div>
        <div class="d-flex flex-column flex-grow-1 mr-2">
          <a
            href="https://obsproject.com/"
            target="_blank"
            class="font-weight-bolder text-dark-75 text-hover-primary font-size-lg mb-1"
          >
            نرم افزار obs
          </a>
        </div>
      </div>
      <div class="d-flex align-items-center flex-wrap mb-5">
        <div class="symbol symbol-50 symbol-light mr-5">
          <span class="symbol-label">
            <img
              src="/media/apps/larix-logo.png"
              class="h-50 align-self-center"
              alt=""
            />
          </span>
        </div>
        <div class="d-flex flex-column flex-grow-1 mr-2">
          <a
            href="https://apps.apple.com/us/app/larix-broadcaster/id1042474385"
            target="_blank"
            class="font-weight-bolder text-dark-75 text-hover-primary font-size-lg mb-1"
          >
            نرم افزار larix
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "download-apps"
};
</script>
